module.exports = __webpack_public_path__ + "img/cat-01-in.aa4c2aae.svg";